/**
 * Display name for a business entity. Entities whose incorporation is still in
 * progress have no legal name yet, so they fall back to `New {countryCode} entity`.
 * A name of only spaces counts as no name.
 */
export const getEntityDisplayName = ({
  legalName,
  incorporationCountry,
}: {
  legalName?: string | null;
  incorporationCountry?: string | null;
}): string => {
  const name = legalName?.trim();
  if (name) return name;

  return incorporationCountry
    ? `New ${incorporationCountry} entity`
    : 'New entity';
};
